import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

// Import images
import heroImage from "@/assets/images/hero.png";
import logoImage from "@/assets/images/logo.png";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToQuote = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative min-h-[100svh] flex items-center overflow-hidden">
      {/* Background image with parallax-friendly fixed positioning */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt="Concrete crew finishing a freshly poured driveway"
          className="w-full h-full object-cover"
        />
        {/* Overlay gradients */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/65 via-white/50 to-white/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-white/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Top logo */}
          <div
            className="flex justify-start animate-fade-in-up mb-10"
            style={{ animationDelay: "0.05s", opacity: 0 }}
          >
            <img
              src={logoImage}
              alt="NCC Logo"
              className="object-contain object-left sm:w-72 md:w-80 h-auto w-20"
            />
          </div>

          <h1
            className="headline text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-4 animate-fade-in-up text-[#646b76]"
            style={{ animationDelay: "0.1s", opacity: 0 }}
          >
            Strong Foundations. <br className="hidden sm:block" />
            Lasting Results.
          </h1>

          <p
            className="headline text-2xl sm:text-3xl md:text-4xl mb-6 animate-fade-in-up text-[#194d32]"
            style={{ animationDelay: "0.2s", opacity: 0 }}
          >
            Concrete Work Done Right.
          </p>

          <p
            className="leading-relaxed max-w-xl mb-8 animate-fade-in-up text-xl sm:text-xl text-[#194d32]/[0.8]"
            style={{ animationDelay: "0.3s", opacity: 0 }}
          >
             Professional concrete solutions for homes and businesses throughout Northwest Arkansas and surrounding areas. From driveways and foundations to slabs and patios, NCC delivers dependable concrete work built to last.
          </p>

          <div
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up"
            style={{ animationDelay: "0.4s", opacity: 0 }}
          >
            <button
              onClick={scrollToQuote}
              className="group flex items-center justify-center gap-2 hover:bg-white text-white hover:text-[hsl(var(--navy))] font-heading text-lg tracking-wider px-8 py-4 rounded-sm transition-all hover:shadow-2xl hover:shadow-[hsl(var(--accent))]/40 focus-ring bg-[#194d32]"
            >
              BUILT A SOLID FUNDATION
              <ArrowRight
                size={20}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("trust")}
        className="absolute bottom-20 sm:bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#194d32]/60 hover:text-[#194d32] transition-colors animate-bounce hidden sm:block"
        aria-label="Scroll down"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
}